import React from "react";
import "./hallSignificantSection.scss";

type Props = {
    significant: string;
};

export default function HallSignificantSection({ significant }: Props) {
    return (
        <section className="significant-container">
            <h2>특이사항</h2>
            <p>{significant}</p>
        </section>
    );
}
